import { RESULT_STATUS } from '../constants';
import { useGetStudentAssignment } from '../queries';
import { useContextEffect } from './useBetterHooks';

const REFETCH_INTERVAL = 5_000;
const useAssignmentResultsRefetch = (studentAssignmentId) => {
  const {
    isLoading,
    isFetching,
    isFetchedAfterMount,
    data: assignmentData,
    refetch: refetchAssignmentData
  } = useGetStudentAssignment(studentAssignmentId);

  // Poll for the results if they are not available
  useContextEffect({
    deps: [assignmentData, isFetching],
    ctx: { assignmentData },
    cb: (ctx) => {
      // If the assignment data is still loading
      if (isLoading || isFetching) {
        return;
      }

      if (
        !ctx.assignmentData?.result ||
        ctx.assignmentData?.result?.status !== RESULT_STATUS.COMPLETED
      ) {
        setTimeout(() => {
          refetchAssignmentData();
        }, REFETCH_INTERVAL);
      }
    }
  });

  return {
    isLoading,
    isFetching,
    // True only once the query has fetched *after this component mounted*. The results/end page
    // shares the ['studentAssignment', id] cache with the assignment-taking screen, so on mount
    // React Query can briefly hand back the stale pre-end status (STARTED/IN_PROGRESS). Callers
    // gate on this to avoid acting on that stale snapshot (e.g. a false "Invalid URL" redirect).
    isFetchedAfterMount,
    assignmentData
  };
};

export default useAssignmentResultsRefetch;
